import { Icon } from "swing-components";

type SharedModalHeaderProps = {
  title: string;
  onDismiss: () => void;
};

export function SharedModalHeader(props: SharedModalHeaderProps) {
  const { title, onDismiss } = props;

  return (
    <div
      css={{
        position: "sticky",
        top: "var(--ion-safe-area-top)",
        padding: 16,
        background: "white",
        display: "flex",
        justifyContent: "space-between",
        zIndex: 999,
      }}
    >
      <span css={{ fontSize: 20 }}>{title}</span>
      <div css={{ cursor: "pointer" }} onClick={onDismiss}>
        <Icon name="Close" color="var(--swing-blue500)" />
      </div>
    </div>
  );
}
